// import { Icon, Label } from 'semantic-ui-react'
import { useAccount } from '../../entities'
import React, { useState } from 'react'

export default function LogoName() {
  // {
  //   // personAddress,
  // }
  const [accountData] = useAccount()
  const [state, setState] = useState({
    is_logo: false
  })

  const { is_logo } = state
  return (
    <>
      {is_logo ? (
        <div style={{ maxWidth: 300, margin: '0 auto' }}>
          <img
            src="/assets/logo.png"
            onError={() => setState({ ...state, is_logo: false })}
            alt={
              accountData.accountSettings
                ? accountData.accountSettings.account_name
                : 'Admin'
            }
            className="app-logo"
            style={{ width: '100%' }}
          />
        </div>
      ) : (
        <div
          style={{
            maxWidth: 300,
            margin: '0 auto',
            fontSize: '35px',
            fontWeight: 'bold',
            lineHeight: '1em'
          }}>
          {accountData.accountSettings
            ? accountData.accountSettings.account_name
            : 'Admin'}
        </div>
      )}
    </>
  )
}
